import { Typography } from '@navi/web-ui/lib/primitives';
import { airtelCallTypesMap, callTypesMap } from '../../constants/communicationHistory.constant';
import { DateFormat, dateFormat, utcToIST } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { DateTimeFormat } from '@cp/src/components/DateTimePicker/constants';

interface CallDetailsViewFeedbackProps {
  interactionData: any;
}

const CallDetailsViewFeedback = (props: CallDetailsViewFeedbackProps) => {
  const { interactionData } = props;
  const dateTimeStamp = Number(interactionData?.metadata?.startTime);

  const naviNumber = interactionData?.metadata?.didNumber || 'NA';
  const ownerName = interactionData?.metadata?.ownerName || 'NA';
  const callType = interactionData?.metadata?.callType || 'NA';
  const callStatus = interactionData?.metadata?.status || 'NA';

  return (
    <div className="mb-6">
      <Typography variant="h4" color={'var(--navi-color-gray-c1)'} className="mb-4">
        Call Details
      </Typography>
      <div className="h-[34px] bg-[var(--grayscale-background-secondary)] items-center flex flex-row p-4 gap-4 rounded-lg ">
        <div className="flex flex-col gap-1 w-[120px]">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'}>
            Navi Number
          </Typography>
          <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
            {naviNumber}
          </Typography>
        </div>
        <div className="flex flex-col gap-1 w-[120px]">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'}>
            Assigned to
          </Typography>
          <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
            {ownerName}
          </Typography>
        </div>
        <div className="flex flex-col gap-1 w-[120px]">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'}>
            Mode
          </Typography>
          <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
            {airtelCallTypesMap.get(callType)}
          </Typography>
        </div>
        <div className="flex flex-col gap-1 w-[120px]">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'}>
            Status
          </Typography>
          <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
            {callStatus}
          </Typography>
        </div>

        <div className="flex flex-col gap-1 w-[180px]">
          <Typography variant="p5" color={'var(--navi-color-gray-c3)'}>
            Date & Time
          </Typography>
          <div className="flex">
            <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
              {dayjs(dateTimeStamp).format(DateTimeFormat.DATE_ONLY)}
            </Typography>
            <Typography variant="p3" color={'var(--navi-color-gray-c3)'} className="mx-[2px]">
              {'|'}
            </Typography>
            <Typography variant="p3" color={'var(--navi-color-gray-c2)'}>
              {dayjs(dateTimeStamp).format(DateTimeFormat.TIME_ONLY)}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallDetailsViewFeedback;
